module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE MA-1 TUBE AMPLIFIER.ec23a002.png";